import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AdminRoutingModule } from "./admin-routing.module";
import { MaterialModule } from "../material/material-module";
import { AdminSidebarComponent } from "./admin-sidebar/admin-sidebar.component";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AdminTrucksComponent } from "./admin-trucks/admin-trucks.component";
import { AdminDriversComponent } from "./admin-drivers/admin-drivers.component";
import { AdminMappingComponent } from "./admin-mapping/admin-mapping.component";
import { AdminTaxComponent } from "./admin-tax/admin-tax.component";
import { AdminGpsComponent } from "./admin-gps/admin-gps.component";
import { AdminDocumentsComponent } from "./admin-documents/admin-documents.component";
import { AdminTripsComponent } from "./admin-trips/admin-trips.component";
import { AdminPaymentsComponent } from "./admin-payments/admin-payments.component";
import { AdminUsersComponent } from "./admin-users/admin-users.component";
import { AdminWebPagesComponent } from "./admin-web-pages/admin-web-pages.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AdminheaderComponent } from "./adminheader/adminheader.component";
import { AdminProfileComponent } from "./admin-profile/admin-profile.component";
import { AdminAddNotesComponent } from "./admin-add-notes/admin-add-notes.component";
import { AdminLoadComponent } from "./admin-load/admin-load.component";
import { AdminTruckCategoryComponent } from "./admin-truck-category/admin-truck-category.component";
import { AdminAddTruckCategoryComponent } from "./admin-add-truck-category/admin-add-truck-category.component";
import { AdminTruckTypeComponent } from "./admin-truck-type/admin-truck-type.component";
import { AdminAddTruckTypeComponent } from "./admin-add-truck-type/admin-add-truck-type.component";
import { AdminTaxEditComponent } from "./admin-tax-edit/admin-tax-edit.component";
import { AdminAddTaxComponent } from "./admin-add-tax/admin-add-tax.component";
import { AdminAddGpsComponent } from "./admin-add-gps/admin-add-gps.component";
import { AdminAddDocumentsComponent } from "./admin-add-documents/admin-add-documents.component";
import { AdminEditDocumentComponent } from "./admin-edit-document/admin-edit-document.component";
import { AdminAddLoadComponent } from "./admin-add-load/admin-add-load.component";
import { AdminAddPaymentsComponent } from "./admin-add-payments/admin-add-payments.component";
import { AdminAddWebPagesComponent } from "./admin-add-web-pages/admin-add-web-pages.component";
import { AdminTrackComponent } from "./admin-track/admin-track.component";
import { AdminTrackNewComponent } from "./admin-track-new/admin-track-new.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { AdminEditDriversComponent } from "./admin-edit-drivers/admin-edit-drivers.component";
import { AdminTrucksViewComponent } from "./admin-trucks-view/admin-trucks-view.component";
import { AdminAddOrdersComponent } from "./admin-add-orders/admin-add-orders.component";
import { AdminTripsViewComponent } from "./admin-trips-view/admin-trips-view.component";
import { AdminCancelTripComponent } from "./admin-cancel-trip/admin-cancel-trip.component";
import { AdminLoginComponent } from "./admin-login/admin-login.component";
import { AdminEditTruckCategoryComponent } from "./admin-edit-truck-category/admin-edit-truck-category.component";
import { AdminAddDriverComponent } from "./admin-add-driver/admin-add-driver.component";
import { AdminAddTrucksComponent } from "./admin-add-trucks/admin-add-trucks.component";
import { AdminActivityLogComponent } from "./admin-activity-log/admin-activity-log.component";
import { AdminActivityStatusComponent } from "./admin-activity-status/admin-activity-status.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { AdminUserscustomerViewComponent } from "./admin-userscustomer-view/admin-userscustomer-view.component";
import { AdminUsersTruckownerViewComponent } from "./admin-users-truckowner-view/admin-users-truckowner-view.component";
import { AdminUsersAdminViewComponent } from "./admin-users-admin-view/admin-users-admin-view.component";
import { AdminUsersDriversViewComponent } from "./admin-users-drivers-view/admin-users-drivers-view.component";
import { ReportsComponent } from "../admin/Reports/reports.component";
import { AdminActivityReasonComponent } from "./admin-activity-reason/admin-activity-reason.component";
import { AdminGpsTypeComponent } from "./admin-gps-type/admin-gps-type.component";
import { AdminAddGpsTypeComponent } from "./admin-add-gps-type/admin-add-gps-type.component";
import { AdminGenerateDeviceComponent } from "./admin-generate-device/admin-generate-device.component";
import { AdminTruckownerPaymentComponent } from "./admin-truckowner-payment/admin-truckowner-payment.component";
import { AdminEditGpsTypeComponent } from "./admin-edit-gps-type/admin-edit-gps-type.component";
import { AdminNotifyDriverComponent } from "./admin-notify-driver/admin-notify-driver.component";
import { AdminCreateWorkorderComponent } from "./admin-create-workorder/admin-create-workorder.component";
import { AdminWorkorderComponent } from "./admin-workorder/admin-workorder.component";
import { AddWorkorderComponent } from "./add-workorder/add-workorder.component";
import { AdminAddGeneralComponent } from "./admin-add-general/admin-add-general.component";
import { AdminDoTruckownerComponent } from "./admin-do-truckowner/admin-do-truckowner.component";
import { AdminEditWorkorderComponent } from "./admin-edit-workorder/admin-edit-workorder.component";
import { AdminUserAdminResetPasswordComponent } from "./admin-user-admin-reset-password/admin-user-admin-reset-password.component";
import { AdminUsersCreateEmployeeLoginComponent } from "./admin-users-create-employee-login/admin-users-create-employee-login.component";
import { AdminUsersEmployeesViewComponent } from "./admin-users-employees-view/admin-users-employees-view.component";
import { AdminUsersAdminAddComponent } from "./admin-users-admin-add/admin-users-admin-add.component";
import { AdminTripsEditCreditTripsComponent } from "./admin-trips-edit-credit-trips/admin-trips-edit-credit-trips.component";
import { AdminTripsCancelComponent } from "./admin-trips-cancel/admin-trips-cancel.component";
import { AdminViewWorkOrderComponent } from "./admin-view-work-order/admin-view-work-order.component";
import { AdminEditWorkOrderComponent } from "./admin-edit-work-order/admin-edit-work-order.component";
import { AdminEditTruckownerDoComponent } from "./admin-edit-truckowner-do/admin-edit-truckowner-do.component";
import { AdminEditTripsComponent } from "./admin-edit-trips/admin-edit-trips.component";
import { UppercaseInputDirective } from "../uppercase-input.directive";
import { UpperCaseInputDirective } from "./uppercase-input.directive";
import { TwoDigitDecimaNumberDirective } from "./two-digit-decima-number.directive";
import { ThreeDigitDecimalNumberDirective } from "./three-digit-decimal-number.directive";
import { AlphanumericOnlyDirective } from "./alpha-numeric.directives";
import { AdminRetailNotifyDriverComponent } from "./admin-retail-notify-driver/admin-retail-notify-driver.component";
import { AdminNotificationApproveComponent } from "./admin-notification-approve/admin-notification-approve.component";
import { AdminDriverOrdersComponent } from "./admin-driver-orders/admin-driver-orders.component";
import { AdminRetailEditTripsComponent } from "./admin-retail-edit-trips/admin-retail-edit-trips.component";
import { AddDriverRouteComponent } from "./add-driver-route/add-driver-route.component";
import { AdminCreateDriverRouteComponent } from "./admin-create-driver-route/admin-create-driver-route.component";
import { ViewDriverRouteComponent } from "./view-driver-route/view-driver-route.component";
import { AdminCorporateNotifyDriverComponent } from "./admin-corporate-notify-driver/admin-corporate-notify-driver.component";
import { AdminEditTripsRetailComponent } from "./admin-edit-trips-retail/admin-edit-trips-retail.component";
import { DisableInputDirective } from "./disabled-input.directive";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatNativeDateModule,
} from "@angular/material/core";
import { CustomDateAdapter } from "./custome-directives";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { AdminPreOrdersComponent } from './admin-pre-orders/admin-pre-orders.component';
import { AdminPreOrderEditComponent } from './admin-pre-order-edit/admin-pre-order-edit.component';
import { AdminSettingsComponent } from './admin-settings/admin-settings.component';
import { AdminVendorsComponent } from './admin-vendors/admin-vendors.component';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { AdminCancelQuoteComponent } from './admin-cancel-quote/admin-cancel-quote.component';
import { AdminInvoiceComponent } from './admin-invoice/admin-invoice.component';
import { AdminGenerateInvoiceComponent } from './admin-generate-invoice/admin-generate-invoice.component';
import { AdminElrViewComponent } from './admin-elr-view/admin-elr-view.component';
import { AdminPromotionalNotificationComponent } from './admin-promotional-notification/admin-promotional-notification.component';
import { AdminAddPromotionalNotificationComponent } from './admin-add-promotional-notification/admin-add-promotional-notification.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "dd-MM-yyyy",
  },
  display: {
    dateInput: "dd-MM-yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

// import { AdminUsercustomerEditComponent } from './admin-usercustomer-edit/admin-usercustomer-edit.component';

@NgModule({
  declarations: [
    AdminSidebarComponent,
    AdminDashboardComponent,
    AdminTrucksComponent,
    AdminDriversComponent,
    AdminMappingComponent,
    AdminTaxComponent,
    AdminGpsComponent,
    AdminDocumentsComponent,
    AdminTripsComponent,
    AdminPaymentsComponent,
    AdminUsersComponent,
    AdminWebPagesComponent,
    AdminheaderComponent,
    AdminProfileComponent,
    AdminAddNotesComponent,
    AdminLoadComponent,
    AdminTruckCategoryComponent,
    AdminAddTruckCategoryComponent,
    AdminTruckTypeComponent,
    AdminAddTruckTypeComponent,
    AdminTaxEditComponent,
    AdminAddTaxComponent,
    AdminAddGpsComponent,
    AdminAddDocumentsComponent,
    AdminEditDocumentComponent,
    AdminAddLoadComponent,
    AdminAddPaymentsComponent,
    AdminTrackComponent,
    AdminTrackNewComponent,
    AdminEditDriversComponent,
    AdminAddPaymentsComponent,
    AdminAddWebPagesComponent,
    AdminTrucksViewComponent,
    AdminAddOrdersComponent,
    AdminTripsViewComponent,
    AdminCancelTripComponent,
    AdminLoginComponent,
    AdminEditTruckCategoryComponent,
    AdminAddDriverComponent,
    AdminAddTrucksComponent,
    AdminActivityLogComponent,
    AdminActivityStatusComponent,
    AdminUserscustomerViewComponent,
    AdminUsersTruckownerViewComponent,
    AdminUsersAdminViewComponent,
    AdminUsersDriversViewComponent,
    ReportsComponent,
    AdminActivityReasonComponent,
    AdminGpsTypeComponent,
    AdminAddGpsTypeComponent,
    AdminGenerateDeviceComponent,
    AdminTruckownerPaymentComponent,
    AdminEditGpsTypeComponent,
    AdminNotifyDriverComponent,
    AdminCreateWorkorderComponent,
    AdminWorkorderComponent,
    AddWorkorderComponent,
    AdminAddGeneralComponent,
    AdminDoTruckownerComponent,
    AdminEditWorkorderComponent,
    AdminUserAdminResetPasswordComponent,
    AdminUsersCreateEmployeeLoginComponent,
    AdminUsersEmployeesViewComponent,
    AdminUsersAdminAddComponent,
    AdminTripsEditCreditTripsComponent,
    AdminTripsCancelComponent,
    AdminViewWorkOrderComponent,
    AdminEditWorkOrderComponent,
    AdminEditTruckownerDoComponent,
    AdminEditTripsComponent,
    UppercaseInputDirective,
    UpperCaseInputDirective,
    TwoDigitDecimaNumberDirective,
    ThreeDigitDecimalNumberDirective,
    AlphanumericOnlyDirective,
    AdminRetailNotifyDriverComponent,
    AdminNotificationApproveComponent,
    AdminDriverOrdersComponent,
    AdminRetailEditTripsComponent,
    AddDriverRouteComponent,
    AdminCreateDriverRouteComponent,
    ViewDriverRouteComponent,
    AdminCorporateNotifyDriverComponent,
    AdminEditTripsRetailComponent,
    DisableInputDirective,
    AdminPreOrdersComponent,
    AdminPreOrderEditComponent,
    AdminSettingsComponent,
    AdminVendorsComponent,
    AdminCancelQuoteComponent,
    AdminInvoiceComponent,
    AdminGenerateInvoiceComponent,
    AdminElrViewComponent,
    AdminPromotionalNotificationComponent,
    AdminAddPromotionalNotificationComponent,
    // CustomDateAdapterDirective,
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    GoogleMapsModule,
    AngularEditorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TableModule,
    ButtonModule,
    PaginatorModule,
    InputTextModule,
    CardModule,
    TooltipModule,
  ],
  // exports: [CustomDateAdapterDirective],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminModule {}
